import React from 'react';
import Button from '@mui/material/Button';
import './LockInButton.scss'

//FACTORIZED BUTTON
function PercentageResponse(props) {
    return (
        <div className='lock-in-btn-wrapper'>
            { props.responseSubmitted? null : 
                <Button 
                className="button-primary"
                    sx={{ 
                        color: 'white', 
                        '&:hover': {backgroundColor: '#A7B0CB'},
                    }} 
                    disabled={props.disabled}
                    onClick={(e) => { props.handleLockInResponse(props.response, e)} }>
                    View actual responses
                </Button> }
        </div>
    );
}

export default PercentageResponse;
